export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Address type"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account Type"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create an address"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create an account"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creating a new address"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create New Account"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter Name"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Currency"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Type"])}
}